import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AngularFireDatabase, FirebaseObjectObservable} from 'angularfire2/database';
import {ToastrService} from 'toastr-ng2';
@Component({
    selector: 'app-business-info',
    templateUrl: './business-info.component.html',
    styleUrls: ['./business-info.component.scss']
})
export class BusinessInfoComponent {
    business = {
        email: '',
        description: '',
        address: '',
        facebookLink: '',
        twitterLink: '',
        officeLocation: '',
        phoneNo: '',
        storeName: ''
    
    };
    businessData: FirebaseObjectObservable<any>;
    constructor(public af: AngularFireDatabase, public toastr: ToastrService) {
        this.businessData = af.object('/business');
        this.businessData.subscribe((res) => {
            this.business = res;
        });
    }

    onSubmitBusiness(form: NgForm) {
        this.businessData.set({
            email: this.business.email,
            description: this.business.description,
            address: this.business.address,
            facebookLink: this.business.facebookLink,
            twitterLink: this.business.twitterLink,
            officeLocation: this.business.officeLocation,
            phoneNo: this.business.phoneNo,
            storeName: this.business.storeName
        }).then((res) => {
            this.toastr.success('Your Business details updated!', 'Success!');
        });
    }
}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/business-info/business-info.component.ts